import { WindowObj } from '@utils/windowObj';

const ROCKETMILES_LEGACY_ORIGINS = ['agoda.rocketmiles.com'];
export const isRocketmilesLegacy = (): boolean => {
    const origin = WindowObj.location?.hostname?.toLowerCase() || '';
    return ROCKETMILES_LEGACY_ORIGINS.includes(origin);
};

const ROCKETMILES_R2_ORIGIN = 'search.rocketmiles.com';
export const isRocketmilesR2 = (): boolean => {
    const hostname = WindowObj.location?.hostname?.toLowerCase() || '';
    return hostname === ROCKETMILES_R2_ORIGIN || hostname.endsWith(`${ROCKETMILES_R2_ORIGIN}`);
};
